






interface IWithBackground {
  children: React.ReactNode
}

const WithBackground: React.FC<IWithBackground> = ({children}) => {

  return(
    <div style={{...style, display:'flex', flexGrow:1, flexDirection:'column'}}>
      {children}
    </div>
  )
}

const style = {
  backgroundSize:'cover',
  backgroundColor: '#C4D4DE',
  backgroundImage: 'url("/stream.png")',
  backgroundPositionY: '35vh',
  height: '100%',
  width: '100%'
}

export default WithBackground